import { Box, Grid, Pagination } from "@mui/material";
import { useState } from "react";
import Thumb from "../../../../../assets/images/DummyThumb.png";
import RecentHuddleCard from "../RecentHuddleCard";

const CallUploads = ({ uploadedCalls, isLoading, deleteHandler }: any) => {
    const [currentPage, setCurrentPage] = useState(1);
    const pageSize = 12;

    const calls = uploadedCalls || [];

    const sortedUploads = [...calls].sort((a: any, b: any) => {
        const aDate = new Date(a?.createdAt)?.getTime();
        const bDate = new Date(b?.createdAt)?.getTime();
        return bDate - aDate;
    });

    const totalItems = sortedUploads.length;
    const totalPages = Math.ceil(totalItems / pageSize);
    const startIndex = (currentPage - 1) * pageSize;
    const paginatedUploads = sortedUploads.slice(startIndex, startIndex + pageSize);

    const handlePageChange = (_: React.ChangeEvent<unknown>, value: number) => {
        setCurrentPage(value);
    };

    return (
        <Box>
            {!isLoading && sortedUploads.length === 0 && (
                <div className="bg-white w-full my-[3rem] text-center py-12 rounded-lg">
                    <p className="text-4xl sm:text-5xl text-primary_blue">No Recordings Found</p>
                </div>
            )}

            {isLoading ? (
                <div className="bg-white w-full my-[3rem] text-center py-12 rounded-lg">
                    <p className="text-4xl sm:text-5xl text-primary_blue">Loading...</p>
                </div>
            ) : (
                sortedUploads.length > 0 && (
                    <>
                        <Grid container spacing="2rem" marginTop="0rem">
                            {paginatedUploads.map((item: any, index: number) => (
                                <Grid item xs={12} sm={6} md={4} key={index}>
                                    <RecentHuddleCard
                                        title={item?.title}
                                        detail={item?.detail}
                                        thumbnail={item?.thumbnail || Thumb}
                                        id={item?.id}
                                        item={item}
                                        date={item?.createdAt}
                                        onDelete={deleteHandler}
                                    />
                                </Grid>
                            ))}
                        </Grid>

                        {
                            totalPages > 1 && (
                                <Box
                                    sx={{
                                        display: "flex",
                                        mt: "4rem",
                                        gap: "2rem",
                                        alignItems: "center",
                                        justifyContent: "center",
                                    }}
                                >
                                    <Pagination
                                        count={totalPages}
                                        page={currentPage}
                                        onChange={handlePageChange}
                                        color="primary"
                                        size="large"
                                    />
                                </Box>
                            )
                        }
                    </>
                )
            )}
        </Box>
    );
};

export default CallUploads;
